export default [
  {
    path: "/", 
    redirect: "/dashboard"
  },  
  {
    path: "/login",
    name: "login",
    meta: {
      title: "登录", 
      unNeedLogin: true
    },
    component: () => import(/* webpackChunkName: "constantModule" */"@/views/constant/login"),
    hidden: true
  }
]